import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const PaymentPopupComponent = React.lazy(() => import("../Components/RootComponents/PaymentPopupComponent"));
const PaymentPopupPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <PaymentPopupComponent />
      </Suspense>
    </Fragment>
  );
};

export default PaymentPopupPage;
